import { render, staticRenderFns } from "./UserBackground.vue?vue&type=template&id=4a602a2f&scoped=true&"
import script from "./UserBackground.vue?vue&type=script&lang=ts&"
export * from "./UserBackground.vue?vue&type=script&lang=ts&"
import style0 from "./UserBackground.vue?vue&type=style&index=0&id=4a602a2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a602a2f",
  null
  
)

export default component.exports